import { Col, Row } from 'antd'
import { ButtonModal } from 'atom/button'
import configProvider from 'config'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router'
import { useAppState } from 'state'
import { SubSection } from '../../../atom/box'
import { EmptyData } from '../../../components/redesign/emptyData'
import { Links } from '../../../components/routes/paths'
import { useDashboardTranslation } from '../../../hooks/translation/useDashboardTranslation'
import { SummaryStationActivation, Transaction } from '../../../models/transaction'
import { V3HomePageStationActivation } from '../charts/active-users/v3-station-activation'
import { HomePageTransactionOverview } from '../charts/active-users/transaction-overview'
import {
  HomePageStationActivationContainer,
  HomePageTransactionOverviewTableContainer,
} from '../ContainerStyles/homepageStyles'
interface props {
  stationActivationDataEmpty: boolean
  stationActivation: SummaryStationActivation | undefined
  transactions: Transaction[] | undefined
  transactionsLoading: boolean
}

const V3StationActivationSection: React.FC<props> = ({
  stationActivationDataEmpty,
  stationActivation,
  transactions,
  transactionsLoading,
}) => {
  const { IsMobile } = useAppState()
  const history = useHistory()
  const { stationActivationText, transactionOverviewText, seeAllTransactionsText } = useDashboardTranslation()
  const isResponsiveStyling = useMediaQuery({ minWidth: 0, maxWidth: 1144 })
  const makeColumn = useMediaQuery({ minWidth: 0, maxWidth: 1144 })
  const isMobile = IsMobile()

  const defaultColSizes = {
    sm: 24,
    md: 24,
    lg: makeColumn ? 24 : 17,
    xl: 17,
    xxl: 18,
  }

  const customColSize = {
    itsElectric: {
      span: 24,
    },
  }

  return (
    <SubSection end>
      <Row gutter={[15, 15]} style={{ marginBottom: '15px' }}>
        {configProvider.config.network !== 'itsElectric' && (
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={makeColumn ? 24 : 7}
            xl={7}
            xxl={6}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <>
              <h5 className="section-sub-header" style={{ marginBottom: '25px', paddingTop: '5px' }}>
                {stationActivationText}
              </h5>
            </>
            <HomePageStationActivationContainer
              className={`${stationActivationDataEmpty ? 'empty-container' : ''}`}
              isResponsiveStyling={isResponsiveStyling}
            >
              {stationActivationDataEmpty ? (
                <EmptyData />
              ) : (
                <>{stationActivation && <V3HomePageStationActivation stationActivation={stationActivation} />}</>
              )}
            </HomePageStationActivationContainer>
          </Col>
        )}
        <Col
          {...(configProvider.config.network in customColSize
            ? customColSize[configProvider.config.network as keyof typeof customColSize]
            : defaultColSizes)}
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row' }}>
            <h5 className="section-sub-header" style={{ marginBottom: 0, paddingTop: '5px' }}>
              {transactionOverviewText}
            </h5>
            <ButtonModal
              size="large"
              style={{ marginBottom: '15px' }}
              click={() => history.push(Links.transactions())}
              text={seeAllTransactionsText}
              type="ghost"
            />
          </div>
          <HomePageTransactionOverviewTableContainer>
            {transactions && (
              <HomePageTransactionOverview transactions={transactions} transactionsLoading={transactionsLoading} />
            )}
          </HomePageTransactionOverviewTableContainer>
        </Col>
      </Row>
    </SubSection>
  )
}

export default V3StationActivationSection
